export default {
    case_outcome_1: '+PDCFS',
    case_outcome_2: '-PDCFS',
    case_outcome_3: 'Death',
    case_outcome_100: 'NaN',
};
